module.exports = __webpack_public_path__ + "static/img/3.8297bbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/3.png
// module id = QX+q
// module chunks = 0